import { forwardRef } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
/**
* @public
*/
const ArrowDownIcon = /* @__PURE__ */ forwardRef(function(props, ref) {
	return /* @__PURE__ */ jsxs("svg", {
		"data-sanity-icon": "arrow-down",
		width: "1em",
		height: "1em",
		viewBox: "0 0 25 25",
		fill: "none",
		xmlns: "http://www.w3.org/2000/svg",
		...props,
		ref,
		children: [/* @__PURE__ */ jsx("path", {
			d: "M12.5 19.5V5",
			stroke: "currentColor",
			strokeWidth: 1.2,
			strokeLinejoin: "round"
		}), /* @__PURE__ */ jsx("path", {
			d: "M18 14L12.5 19.5L7 14",
			stroke: "currentColor",
			strokeWidth: 1.2,
			strokeLinejoin: "round"
		})]
	});
});
export { ArrowDownIcon, ArrowDownIcon as default };

//# sourceMappingURL=ArrowDown.js.map